import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API } from '../App';
import './OnboardingPage.css';

const LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English',  flag: '🇬🇧' },
  { code: 'es', label: 'Español',  flag: '🇪🇸' },
];

export default function OnboardingPage({ practitionerId, onComplete }) {
  const { t, i18n } = useTranslation();
  const [form, setForm] = useState({
    name: '', cabinet: '', address: '', phone: '', email: '', language: 'fr',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const selectLanguage = (code) => {
    setForm(f => ({ ...f, language: code }));
    i18n.changeLanguage(code);
    localStorage.setItem('lang', code);
  };

  const handleSubmit = async () => {
    if (!form.name.trim()) { setError('Le nom est obligatoire'); return; }
    setSaving(true);
    setError('');
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      const res = await fetch(`${API}/api/practitioners/${practitionerId}`, {
        method: 'POST', body: fd,
      });
      if (!res.ok) throw new Error(`Erreur ${res.status}`);
      localStorage.setItem('lang', form.language);
      onComplete(form);
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="onboarding-page">
      <div className="onboarding-card">
        <div className="onboarding-logo">
          <span className="logo-badge">PA</span>
          <span className="logo-text"><span>PODO</span><span className="logo-sub">ANALYSIS</span></span>
        </div>

        <h1 className="onboarding-title">{t('onboarding.title')}</h1>
        <p className="onboarding-subtitle">{t('onboarding.subtitle')}</p>

        {/* Langue */}
        <div className="onboarding-section">
          <label className="onboarding-label">{t('onboarding.language')}</label>
          <div className="lang-selector">
            {LANGUAGES.map(l => (
              <button
                key={l.code}
                className={`lang-btn ${form.language === l.code ? 'active' : ''}`}
                onClick={() => selectLanguage(l.code)}
              >
                <span className="lang-flag">{l.flag}</span>
                <span>{l.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Infos cabinet */}
        <div className="onboarding-section">
          <div className="fields-row">
            <div className="field">
              <label>{t('onboarding.name')} *</label>
              <input name="name" value={form.name} onChange={handleChange} placeholder="Dr. García" />
            </div>
            <div className="field">
              <label>{t('onboarding.cabinet')}</label>
              <input name="cabinet" value={form.cabinet} onChange={handleChange} placeholder="Clínica Podológica" />
            </div>
          </div>
          <div className="field full">
            <label>{t('onboarding.address')}</label>
            <input name="address" value={form.address} onChange={handleChange} placeholder="Calle Mayor 1, Madrid" />
          </div>
          <div className="fields-row">
            <div className="field">
              <label>{t('onboarding.phone')}</label>
              <input name="phone" value={form.phone} onChange={handleChange} placeholder="+34 600 000 000" />
            </div>
            <div className="field">
              <label>{t('onboarding.email')}</label>
              <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="contact@cabinet.com" />
            </div>
          </div>
        </div>

        {error && <div className="onboarding-error">{error}</div>}

        <button className="btn-onboarding" onClick={handleSubmit} disabled={saving}>
          {saving ? t('common.loading') : t('onboarding.save')}
        </button>
      </div>
    </div>
  );
}
